import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {GetParams, GetResponse, User, UserCreate, PostResponse, UserRole} from '@app/shared';
import {convertGetParamsToHttpParams} from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  /** URLs principales relacionadas con Users **/
  userUrl = environment.identityApiBaseUrl + '/api/user';
  userTypeUrl = environment.identityApiBaseUrl + '/api/user-type';
  companyUrl = environment.identityApiBaseUrl + '/api/company';
  userRolesUrl= environment.identityApiBaseUrl + '/api/user-role';

  constructor(private http: HttpClient) {}

  /** Metodos de obtener/crear/actualizar/eliminar Users **/
  getUsers(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createUser(newUser: UserCreate): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.userUrl, newUser);
  }

  updateUser(user: User): Observable<any> {
    return this.http.put(this.userUrl, user);
  }

  deleteUser(ids: number[]): Observable<any> {
    return this.http.delete(this.userUrl, { params: { ids } });
  }

  getUserRoles(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.userRolesUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  getCompanies(getParams: GetParams): Observable<GetResponse> {
    return this.http.get<GetResponse>(this.companyUrl, {params: convertGetParamsToHttpParams(getParams)});
  }

  createCompany(newCompany: any): Observable<PostResponse> {
    return this.http.post<PostResponse>(this.companyUrl, newCompany);
  }

  updateCompany(user: any): Observable<any> {
    return this.http.put(this.companyUrl, user);
  }

  deleteCompany(ids: number[]): Observable<any> {
    return this.http.delete(this.companyUrl, { params: { ids } });
  }
}
